<template>
  <div id="app" class="app">
    <Header/>
    <div class="app__content">
      <router-view/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/layout/Header.vue';
import Footer from '@/components/layout/Footer.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      loadImages: false,
    };
  },
  mounted() {
    this.$nextTick(function loadImages() {
      this.loadImages = true;
    });
  },
};
</script>

<style lang="scss">
  .app {
    min-height: 100vh;
    box-sizing: border-box;
    position: relative;

    &__content {
      max-width: 1024px;
      margin: 0 auto;
    }
  }
</style>
